import { Project } from "domain/entities/project";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ProjectState {
  project: Project | null;
  setProject: (newProject: Partial<Project>) => void;
  resetProject: () => void;
}

const initialProjectState: Project = {
  id: "",
  description: "",
  name: "",
  status: undefined,
  startAt: undefined,
  endAt: undefined,
  client: { id: "", name: "" },
  createdAt: new Date(),
  modifiedAt: new Date(),
};

export const useProjectStore = create<ProjectState>()(
  devtools(
    (set) => ({
      project: initialProjectState,
      setProject: (newProject) =>
        set((state) => ({
          project: { ...state.project, ...newProject } as Project,
        })),
      resetProject: () => set({ project: initialProjectState }),
    }),
    { name: "ProjectSelected" }
  )
);
